import { z } from "zod";

// Define a schema for breadcrumb structured data
const breadcrumbSchema = z.object({
    data: z
        .array(
            z.object({
                slug: z.string().nonempty("Slug is required"), // Used for the "item" field in structured data
                title: z.string().nonempty("Title is required"), // Used for the "name" field in structured data
            })
        )
        .min(1, "Data must contain at least one breadcrumb"), // Ensure at least one breadcrumb exists
    title: z.string().nonempty("Title is required"),
});

// Function to generate BreadcrumbList structured data
const generateBreadcrumbJsonLd = (data: { slug: string; title: string }[]) => {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": data.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1, // Breadcrumb position starts at 1
            "name": item.title, // Title of the breadcrumb
            "item": `${window.location.origin}/${item.slug}`, 
        })),
    };
};

// Custom hook for schema validation
export const useValidateBreadcrumb = (props: any) => {
    try {
        // Validate the incoming props
        breadcrumbSchema.parse(props);

        // Generate structured data JSON-LD
        const jsonLd = generateBreadcrumbJsonLd(props.data);

        return { isValid: true, error: null, jsonLd };
    } catch (err: any) {
        return { isValid: false, error: err.errors, jsonLd: null };
    }
};
